import { default as React } from "react";
import { MultipleChoiceData } from "__generated__/types";
import { QuestionState } from "./MultipleChoice";
import styles from "./MultipleChoiceQuestion.module.css";

interface Props {
  question: MultipleChoiceData["questions"][0];
  value?: QuestionState;
  index: number;
  goToQuestion: (idx: number) => void;
}

function isAnswered(
  question: MultipleChoiceData["questions"][0],
  value?: QuestionState,
): boolean {
  if (!value) {
    return false;
  }

  let answered = false;
  question.options?.forEach((option) => {
    if (value.selectedOptions.includes(option.id)) {
      answered = true;
    }
  });
  return answered;
}

export const MultipleChoiceSummaryQuestion: React.FC<
  React.PropsWithChildren<Props>
> = ({ question, value, index, goToQuestion }) => {
  return (
    <section
      key={question.id}
      className={
        isAnswered(question, value)
          ? styles.checked + " " + styles.option
          : styles.option
      }
    >
      <label className={styles.label} htmlFor={question.id}>
        <input
          className={styles.input}
          id={question.id}
          type="checkbox"
          checked={isAnswered(question, value)}
          readOnly={true}
          onChange={() => {
            goToQuestion(index);
          }}
        />{" "}
        {index + 1}. {question.title}
      </label>
    </section>
  );
};
